// src/components/Footer.js
import React from 'react';
import './Footer.css';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Sobre Nosotros</h4>
          <p>Soy un desarrollador freelance especializado en soluciones de gestión empresarial. Cre Punto Central para ayudar a negocios como el tuyo a optimizar sus operaciones y crecer de forma eficiente.</p>
        </div>
        <div className="footer-section">
          <h4>Contacto</h4>
          <p>Email: agusvergalobos2016@gmail.com</p>
          <p>Teléfono: 2983-344657</p>
        </div>
        <div className="footer-section">
          <h4>Redes Sociales</h4>
          <ul className="social-links">
            <li><a href="https://www.facebook.com/agustin.vergalobos/" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook"></i></a></li>
            <li><a href="https://twitter.com/VLobosAgus" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter"></i></a></li>
            <li><a href="https://www.instagram.com/vlobos01/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"></i></a></li>
            <li><a href="https://www.linkedin.com/in/agustin-verga-lobos-951a26267/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2024 Punto Central. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;

